import React from 'react'
import PropTypes from 'prop-types'

import {
  NotificationBanner,
  NotificationBannerMessage,
  NotificationBannerAction
} from '@components/NotificationBanner'

export const ScenarioNotifications = ({
  clientHasId, isWealthManager, editClientPath,
  jointScenarioPath
}) => {
  let notificationBanners = []

  if (!clientHasId && isWealthManager) {
    notificationBanners.push(
      <NotificationBanner>
        <NotificationBannerMessage
          text={'The client profile is missing an ID number. Before you can implement any plan, you need to update their details.'}
        />
        <NotificationBannerAction
          text={'Update Client Details'}
          path={editClientPath}
        />
      </NotificationBanner>
    )
  }

  if (jointScenarioPath && isWealthManager) {
    notificationBanners.push(
      <NotificationBanner>
        <NotificationBannerMessage
          text={`${isWealthManager ? 'This client is' : 'You are'} part of a joint plan, hop over there to edit it. You can still create a scenario to explore different options, but it can't be implemented whilst a joint plan exists.`}
        />
        <NotificationBannerAction
          text={'Edit Joint Plan'}
          path={jointScenarioPath}
        />
      </NotificationBanner>
    )
  }

  if (notificationBanners.length === 0) {
    return null
  }

  return (
    <section className="scenario-notifications" style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      {notificationBanners.map(banner => banner)}
    </section>
  )
}

ScenarioNotifications.propTypes = {
  /* Props for client missing ID number banner notification */
  clientHasId: PropTypes.bool.isRequired,
  isWealthManager: PropTypes.bool.isRequired,
  editClientPath: PropTypes.string.isRequired,

  /* Props for plan belonging to a joint plan */
  jointScenarioPath: PropTypes.string
}
